export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        {/* Image Container */}
        <div className="relative rounded-2xl overflow-hidden mb-12 md:mb-16 h-[320px] md:h-[420px]">
          <img
            src="https://readdy.ai/api/search-image?query=Overhead%20view%20of%20an%20organized%20wooden%20desk%20with%20a%20spreadsheet%20on%20a%20tablet%20screen%2C%20surrounded%20by%20a%20pair%20of%20white%20low%20top%20canvas%20sneakers%2C%20a%20ceramic%20mug%20with%20coffee%2C%20round%20sunglasses%2C%20and%20a%20linen%20pouch%2C%20warm%20afternoon%20sunlight%20creating%20long%20soft%20shadows%2C%20cozy%20productive%20aesthetic%2C%20editorial%20lifestyle%20photography&width=1400&height=800&seq=cta-v2-image-01&orientation=landscape"
            alt="CSSBuy Spreadsheet produtos China"
            title="CSSBuy Spreadsheet atualizada 2026"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-foreground-950/10 rounded-2xl"></div>
        </div>

        {/* Text */}
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-950 mb-4 md:mb-6">
          Acesse agora a{" "}
          <span className="italic font-normal text-foreground-600">melhor planilha CSSBuy</span>
          <br />
          atualizada para 2026
        </h2>

        <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto mb-8 md:mb-10 leading-relaxed">
          Não perca mais tempo procurando produtos não verificados. Nossa <strong>planilha CSSBuy</strong> reúne os melhores itens da China, atualizados semanalmente para você.
        </p>

        {/* Button */}
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 bg-foreground-950 text-background-50 px-10 py-4 rounded-full text-sm md:text-base font-semibold cursor-pointer transition-all hover:bg-foreground-800 whitespace-nowrap"
        >
          Buy It Now
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}